/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thankyou_DescriptionInputs */

const en_thankyou_description = /** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your sovereign contribution has been verified. You are now fueled by the community fund. Every dollar accelerates our path to a truly decentralized creative economy.`)
};

const es_thankyou_description = /** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu contribución ha sido verificada. Cada dólar acelera nuestro camino hacia una economía creativa verdaderamente descentralizada.`)
};

const fr_thankyou_description = /** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre contribution souveraine a été vérifiée. Vous êtes maintenant propulsé par le fonds communautaire. Chaque dollar accélère notre chemin vers une économie créative véritablement décentralisée.`)
};

const de_thankyou_description = /** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein souveräner Beitrag wurde verifiziert. Jeder Dollar beschleunigt unseren Weg zu einer dezentralisierten kreativen Wirtschaft.`)
};

const id_thankyou_description = /** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontribusi sovereign Anda telah diverifikasi. Anda sekarang didorong oleh dana komunitas. Setiap dolar mempercepat jalan kami menuju ekonomi kreatif yang benar-benar terdesentralisasi.`)
};

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const ja_thankyou_description = en_thankyou_description;

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const zh_thankyou_description = en_thankyou_description;

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const ar_thankyou_description = en_thankyou_description;

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const it_thankyou_description = en_thankyou_description;

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const ru_thankyou_description = en_thankyou_description;

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const pt_thankyou_description = en_thankyou_description;

/** @type {(inputs: Thankyou_DescriptionInputs) => LocalizedString} */
const ko_thankyou_description = en_thankyou_description;

/**
* | output |
* | --- |
* | "Your sovereign contribution has been verified. You are now fueled by the community fund. Every dollar accelerates our path to a truly decentralized creative ..." |
*
* @param {Thankyou_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thankyou_description = /** @type {((inputs?: Thankyou_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thankyou_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thankyou_description(inputs)
	if (locale === "es") return es_thankyou_description(inputs)
	if (locale === "fr") return fr_thankyou_description(inputs)
	if (locale === "de") return de_thankyou_description(inputs)
	if (locale === "ja") return ja_thankyou_description(inputs)
	if (locale === "zh") return zh_thankyou_description(inputs)
	if (locale === "ar") return ar_thankyou_description(inputs)
	if (locale === "id") return id_thankyou_description(inputs)
	if (locale === "it") return it_thankyou_description(inputs)
	if (locale === "ru") return ru_thankyou_description(inputs)
	if (locale === "pt") return pt_thankyou_description(inputs)
	return ko_thankyou_description(inputs)
});